import { createContext } from "react";
import { CDashboardModuleTabComponent } from "./types";

export enum Mode {
	RUNTIME = "RUNTIME",
	DESIGN = "DESIGN",
}

export type ModeContextType = {
	mode: Mode;
	activeComponent?: CDashboardModuleTabComponent;
	locatorActivated?: boolean;
	setLocatorActivated?: (status: boolean) => void;
	updateActiveComponent?: (comp: CDashboardModuleTabComponent) => void;
	logError?: (message: string) => void;
};

const ExecutionTypeContext = createContext<ModeContextType | undefined>(undefined);

export default ExecutionTypeContext;
